import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Toolbar from "components/Toolbar";
import dayjs from "dayjs";
import { Datepicker, Select } from "flowbite-react";
import useToastContext from "hooks/useToastContext";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { apiPost } from "utils/apiFetch";
import pathObj from "utils/apiPath";

function WalletWindow() {
  const { t } = useTranslation();
  const notification = useToastContext();
  const { handleSubmit } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });

  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    setLoading(true);
    try {
      const requestBody = {
        fromDate: document.getElementById("fromDate").value,
        toDate: document.getElementById("toDate").value,
      };
      const res = await apiPost(pathObj.walletBalanceWindow, requestBody);
      if (res.data.success) {
        var contentType = "";
        var base64 = "";
        var ext = "";
        switch (document.getElementById("formatSelect").value) {
          case "PDF":
            base64 = res.data.results.pdfBase64;
            contentType = "application/pdf";
            ext = "pdf";
            break;
          default:
            base64 = res.data.results.excelBase64;
            contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            ext = "xlsx";
            break;
        }

        const dataUrl = `data:${contentType};base64,${base64}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = dataUrl;
        downloadLink.download = `pasqyre_gjendjeje.${ext}`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      } else {
        notification.error(res.data.message);
      }
    } catch (err) {}
    setLoading(false);
  };

  return (
    <>
      <Toolbar title={t("WALLET_WINDOW")} showBackBtn={true} />
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col w-full justify-center items-center">
        <div className="px-4 py-4 md:py-[unset] rounded-3xl h-full w-full md:w-[25rem]">
          <div className="mt-2 mx-2">
            <div className="text-lg font-medium  mt-5 mb-2">{t("FROM")}</div>
            <Datepicker showClearButton={true} id="fromDate" weekStart={1} maxDate={new Date()} defaultValue={dayjs().month(0).toDate()} />

            <div className="text-lg font-medium  mt-5 mb-2">{t("TO")}</div>
            <Datepicker showClearButton={true} id="toDate" weekStart={1} maxDate={new Date()} defaultValue={new Date()} />

            <div className="text-lg font-medium  mt-5 mb-2">{t("Format")}</div>
            <Select id="formatSelect" required>
              <option>PDF</option>
              <option>EXCEL</option>
            </Select>

            <div className="w-full mt-[5rem]">
              {loading ? (
                <div className="btn btn_theme w-full flex items-center justify-center p-3">
                  <FontAwesomeIcon icon={faCircleNotch} className="text-white text-xl animate-spin" />
                </div>
              ) : (
                <button className="btn btn_theme w-full text-white" type="submit">
                  {t("CONFIRM")}
                </button>
              )}
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default WalletWindow;
